import React from 'react';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import { Trash2, Plus } from 'lucide-react';

const InvoiceItems = ({ items = [], handleItemInputChange = () => { }, addItemDiv = () => { }, removeItemDiv = () => { } }) => {
  return (
    <div className="p-4 sm:p-6 border-b border-gray-100">
      <h3 className="text-[14px] font-bold text-gray-900 mb-4 sm:mb-5">Артикули</h3>

      <div className="overflow-x-auto -mx-4 px-4 sm:-mx-6 sm:px-6 lg:mx-0 lg:px-0">
        <div className="min-w-[500px]">
          <div className="grid grid-cols-[1fr_120px_120px_120px_40px] gap-4 mb-3 px-2">
            <div className="text-[11px] font-bold text-gray-900 uppercase tracking-wide">Артикул</div>
            <div className="text-[11px] font-bold text-gray-900 uppercase tracking-wide">Количество</div>
            <div className="text-[11px] font-bold text-gray-900 uppercase tracking-wide">Ед. цена</div>
            <div className="text-[11px] font-bold text-gray-900 uppercase tracking-wide">Общо</div>
            <div></div>
          </div>

          {items.map((item, index) => {
            const quantity = parseFloat(item.itemQuantity) || 0;
            const price = parseFloat(item.itemPrice) || 0;
            const total = (quantity * price).toFixed(2);

            return (
              <div key={index} className="bg-gray-50/50 p-2 rounded-xl mb-4 group">
                <div className="grid grid-cols-[1fr_120px_120px_120px_40px] gap-4 items-center">
                  <Input
                    type="text"
                    name="itemName"
                    placeholder="Изберете или въведете артикул..."
                    className="bg-white"
                    value={item.itemName || ''}
                    onChange={(e) => handleItemInputChange(e, index)}
                  />
                  <Input
                    type="number"
                    name="itemQuantity"
                    placeholder="1"
                    className="bg-white"
                    value={item.itemQuantity || ''}
                    onChange={(e) => handleItemInputChange(e, index)}
                  />
                  <Input
                    type="number"
                    name="itemPrice"
                    placeholder="0.00"
                    className="bg-white"
                    value={item.itemPrice || ''}
                    onChange={(e) => handleItemInputChange(e, index)}
                  />
                  <div className="text-[13px] text-gray-900 font-medium px-2 truncate">
                    {total}
                  </div>
                  <div className="flex justify-center">
                    {items.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeItemDiv(index)}
                        className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors opacity-100 lg:opacity-0 lg:group-hover:opacity-100"
                        title="Изтрий ред"
                      >
                        <Trash2 size={16} strokeWidth={2} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mt-6 gap-4">
        <Button
          type="button"
          onClick={addItemDiv}
          variant="secondary"
          size="sm"
          className="gap-2 text-tenant-dark border-tenant-dark/20 hover:bg-tenant-light w-full sm:w-auto"
        >
          <Plus size={16} strokeWidth={2} />
          Добави ред
        </Button>
      </div>
    </div>
  );
};

export default InvoiceItems;
